export default __webpack_public_path__ + "daa9b00495abab81cd26138fae628736.svg";